import { apiClient } from '../../../lib/api/client';

export interface ImportError {
  rowNumber: number;
  column: string | null;
  message: string;
}

export interface ImportContactsResponse {
  importedCount: number;
  bulkOperationId: string;
  purpose: string | null;
  errors: ImportError[];
}

export interface RevertImportResponse {
  revertedCount: number;
}

export interface BulkOperationListItem {
  id: string;
  operationType: string;
  purpose: string | null;
  status: string;
  initiatedByUserId: string;
  initiatedByEmail: string;
  initiatedAtUtc: string;
  completedAtUtc: string | null;
  revertedAtUtc: string | null;
  revertedByUserId: string | null;
  totalItems: number;
  successCount: number;
  failureCount: number;
  metadata: string | null;
}

export interface PagedBulkOperationsResponse {
  items: BulkOperationListItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

export async function downloadImportTemplate(): Promise<Blob> {
  const response = await apiClient.get<Blob>('/contacts/import/template', {
    responseType: 'blob',
  });
  return response.data;
}

export async function importContacts(file: File): Promise<ImportContactsResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await apiClient.post<ImportContactsResponse>('/contacts/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function revertContactImport(bulkOperationId: string): Promise<RevertImportResponse> {
  const response = await apiClient.post<RevertImportResponse>('/contacts/import/revert', {
    bulkOperationId,
  });
  return response.data;
}

export async function getBulkOperations(
  pageNumber: number,
  pageSize: number,
  operationType?: string,
): Promise<PagedBulkOperationsResponse> {
  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));
  if (operationType) searchParams.set('operationType', operationType);
  const response = await apiClient.get<PagedBulkOperationsResponse>(
    `/bulk-operations?${searchParams.toString()}`,
  );
  return response.data;
}
